import "./index.css";

import ContentHero from "../../comps/contentHero";
import React from "react";
import { Star } from "@mui/icons-material/";
import accident_image from "../../assets/accident_page_image.jpg";
import { useTranslation } from "react-i18next";

export default function AccidentPage() {
  const { t } = useTranslation();
  const features = [
    {
      name: t("accidentPage.feature1.title"),
      description: t("accidentPage.feature1.description"),
      // icon: CloudArrowUpIcon,
    },
    {
      name: t("accidentPage.feature2.title"),
      description: t("accidentPage.feature2.description"),
      // icon: LockClosedIcon,
    },
    {
      name: t("accidentPage.feature3.title"),
      description: t("accidentPage.feature3.description"),
      // icon: ServerIcon,
    },
    {
      name: t("accidentPage.feature4.title"),
      description: t("accidentPage.feature4.description"),
      // icon: ServerIcon,
    },
    {
      name: t("accidentPage.feature5.title"),
      description: t("accidentPage.feature5.description"),
      // icon: ServerIcon,
    },
    {
      name: t("accidentPage.feature6.title"),
      description: t("accidentPage.feature6.description"),
      // icon: ServerIcon,
    },
    {
      name: t("accidentPage.feature7.title"),
      description: t("accidentPage.feature7.description"),
      // icon: ServerIcon,
    },
  ];
  return (
    <div className="overflow-hidden bg-white py-0 sm:py-0 max-sm:py-3 ">
      <ContentHero title={t("accidentPage.banner_text")}></ContentHero>
      <div className="mx-auto max-w-full md:px-6 lg:px-32">
        <div className=" flex gap-x-8 gap-y-16 sm:gap-y-20 lg:justify-evenly ">
          <div className="px-6 md:px-0 lg:pr-4 lg:pt-4">
            <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-full">
              <img
                src={accident_image}
                alt=""
                width="650px"
                style={{ float: "right", borderRadius: 10 }}
              />
              {/* <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{t('repairPage.title')}</p> */}
              <p className="mt-6 text-lg leading-8 text-gray-600">
                {t("repairPage.introduction")}
              </p>
              <dl className="mt-10 mb-10 max-w-xl space-y-8 text-base leading-7 text-gray-600 lg:max-w-none ">
                {features.map((feature) => (
                  <div
                    key={feature.name}
                    className="relative pl-9 w-1/2 max-sm:w-full"
                  >
                    <dt className="inline-block font-semibold text-gray-900">
                      <Star
                        className="absolute left-1 top-1 h-5 w-5 text-[#FE5D27]"
                        aria-hidden="true"
                      />
                      {feature.name}
                    </dt>{" "}
                    <dd className="inline">{feature.description}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
          <div className="sm:px-6 lg:px-0"></div>
        </div>
      </div>
    </div>
  );
}
